export * from './WordPairingIndex/WordPairingIndex';
export * from './WordPairingNew/WordPairingNew';
export * from './WordPairingShow/WordPairingShow';
